import _ from 'underscore';
import Polyglot from 'node-polyglot';
import Handlebars from 'handlebars-template-loader/runtime';
import jQuery from 'jquery';
import GoogleMapsUtils from 'helpers/GoogleMapsUtils';

import MessageControlCollection from './widgetHelpers/messageControl/MessageControlCollection';

import getPreloadedJson from 'helpers/getPreloadedJson';

/**
 * @classdesc Helper class for building Widget Classes
 * @memberof core.widget
 * @alias WidgetCommon
 * @abstract
 */
class WidgetCommon {

  /**
   * Override JSON object configuration
   * @static
   * @protected
   * @param {object} config The config provided by json
   * @param {object} widget - The widget
   */
  static prepareConfig(conf, widget) {

    function process(obj, key, value) {
      if (key === 'cluster' && _.isString(value)) {
        if (conf.clustersConf[value]) {
          obj[key] = conf.clustersConf[value];
        }
      }
    }

    function traverse(data, func) {
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          func.apply(widget, [data, i, data[i]]);
          if (data[i] !== null && typeof(data[i]) === 'object') {
            traverse(data[i], func);
          }
        }
      }
    }
    traverse(conf, process);
    return conf;
  }

  /**
   * Set language to the widget
   * @static
   * @protected
   * @param {object} widget - The widget
   */
  static setLocale(widget) {
    let promise = jQuery.Deferred();
    let config = widget.config.locale ? widget.config.locale : {};
    let lang = (_.isUndefined(config.preloaded)) ? 'en' : config.preloaded;
    let locale, customLocale;
    try {
      locale = require(`data/locales/${lang}.json`);
    } catch (e) {
      locale = require('data/locales/en.json');
    }

    let polyglot = new Polyglot({ phrases: locale });
    widget.polyglot = polyglot;
    try {
      customLocale = getPreloadedJson(`locales/${lang}.json`);
    } catch (e) {
      customLocale = getPreloadedJson(`locales/en.json`);
      console.warn('Language file cannot be found.');
    }

    polyglot.extend(customLocale);

    if (config.url) {
      jQuery.getJSON(config.url).done((json) => {
        polyglot.extend(json);
        promise.resolve();
      });
    } else if (config.strings) {
      polyglot.extend(config.strings);
      promise.resolve();
    } else {
      //We don't extend the polyglot object but we need to finish the promise
      promise.resolve();
    }
    return promise;
  }

  /**
   * New helpers to use in handlebars template
   * @static
   * @protected
   * @param {object} widget - The widget
   */
  static registerHelpers(widget) {
    Handlebars.registerHelper('t', (string) => {
      return widget.polyglot.t(string);
    });

    Handlebars.registerHelper('list', function(items, options) {
      var i, l, out = '<ul>',
        className;
      for (i = 0, l = items.length; i < l; i++) {
        if (items[i]) {
          className = i === l - 1 ? 'lastItem' : '';
          out = out + '<li class="' + className + '">' + options.fn(items[i]) + '</li>';
        }
      }
      return out + '</ul>';
    });
  }

  /**
   * Added the components defined by config
   * @static 
   * @param {core.widget.Widget}
   * @param {object} configComponents - The configuration of the components
   */
  static addCustomComponents(widget, configComponents, Components) {
    let components = _.filter(configComponents, function(component, key) {
      if (!component || _.indexOf(GoogleMapsUtils.googleControls, component.componentConstructorClass) !== -1) {
        return false;
      } else {
        component.identifier = key;
        return true;
      }
    });

    _.each(components, (component, key) => {
      if (_.isObject(Components[component.componentConstructorClass])) {
        this.registerComponent(new Components[component.componentConstructorClass](_.extend(
          component, {
            map: this.map,
            position: component.position,
            widget: this
          })));
      } else {
        throw new Error('There is not any component with identifier ' + component.componentConstructorClass);
      }
    });
  }

  /**
   * Registers a component into the widget
   * @static 
   * @param {core.widget.Widget}
   * @param {core.components.base.ComponentBase} component The component to be registed.
   */
  static registerComponent(widget, component) {
    widget.customComponents[component.identifier] = component;
  }

  /**
   * This function creates Message Control for all components
   * @static
   * @protected
   */
  static createMessageControl(widget) {
    widget.messageControl = new MessageControlCollection();
  }
}

export default WidgetCommon;



// WEBPACK FOOTER //
// ./lmm-widget/src/widget/WidgetCommon.js